export default __webpack_public_path__ + "static/media/led-matrix-gif.72cdb580.gif";